// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"163":"map","594":"about","608":"header"}[chunkId] + "." + {"163":"8a97e5e4","594":"2dee8aef","608":"6b58ad44"}[chunkId] + ".css";
};